import { useState, useCallback } from 'react'
import { message as $message } from 'antd'
import { transferSearchToData } from '@/pages/TowerQianKun/AfterSalesAutomation/components/PlatformAuto/helper'
import {
    pageEffectiveShopApi,
    modifyAgLaterApi,
    modifyAgEnableStatusApi,
    modifyReceiptGoodsAutoRefundStatusApi
} from '@/services/platformAuto'
import { goToErp } from '@/utils/goToErp'
import { env, envJump } from '@/modules/globals'

export default function usePlatformAuto() {
    const [query, setQuery] = useState({})
    const [queryValues, setQueryValues] = useState({})
    const [listFetchData, setListFetchData] = useState<any>({})

    const reload = () => {
        listFetchData?.reload?.()
    }

    const refresh = () => {
        listFetchData?.refresh?.()
    }

    const fetch = useCallback(
        params => {
            const values = transferSearchToData({
                query
            })
            const targetParams = { ...values, ...params }
            return pageEffectiveShopApi(targetParams)
        },
        [query]
    )
    // 修改延迟执行时间
    const onModifyAgLater = async params => {
        const { success, message } = await modifyAgLaterApi(params)
        if (success) {
            $message.success('修改成功')
            return true
        } else {
            $message.error(message)
        }
    }
    // 修改ag启用状态
    const onModifyAgEnable = async params => {
        const { success, message } = await modifyAgEnableStatusApi(params)
        if (success) {
            $message.success(params?.enableAg ? '启用成功' : '禁用成功')
            return true
        } else {
            $message.error(message)
        }
    }
    // 修改AG确认收货自动退款状态
    const onModifyAgAutoRefund = async params => {
        const { success, message } = await modifyReceiptGoodsAutoRefundStatusApi(params)
        if (success) {
            $message.success(params?.receiptGoodsAutoRefund ? '启用成功' : '禁用成功')
            return true
        } else {
            $message.error(message)
        }
    }
    const lookLog = async shopId => {
        let url = `/?n=店铺设置&u=${encodeURIComponent(`/erp-web-group/shop/shop?gyl_shopId=${shopId}`)}`
        const isGyl = await env.isGyl()
        if (isGyl) {
            const res = await goToErp(`${url}&m=full`)
            window.open(res)
            return
        }
        envJump.open({
            url,
            name: '店铺设置'
        })
    }

    return {
        fetch,
        reload,
        refresh,
        listFetchData,
        setListFetchData,
        queryValues,
        query,
        setQuery,
        setQueryValues,
        onModifyAgLater,
        onModifyAgEnable,
        onModifyAgAutoRefund,
        lookLog
    }
}
